<template lang="pug">
.editar-atalho
    section.editar-atalho__header.row
        .editar-atalho__header__actionclose.col-12
            .editar-atalho__header__actionclose--enabled(
                @click='fecharAcessoRapido'
            )
                i.el.el-icon-close.mr-2
                div(style='font-size: 1.2em') {{ $t('mensagens.comuns.fechar') }}

        .editar-atalho__header__title.col-12 {{ $t('mensagens.home.acessoRapido.editarAtalhos') }}
        .editar-atalho__header__subtitle.col-12 {{ $t('mensagens.home.acessoRapido.adicionarAtalhos') }}

    section.editar-atalho__body.row
        .editar-atalho__body__title.col-12 {{ $t('mensagens.home.acessoRapido.previewPaginaInicial') }}

        .editar-atalho__body__atalhos.col-12
            Atalho(
                v-for='atalho in atalhosAtivos',
                :key='atalho.codigo',
                :atalho='atalho',
                style='margin-right: 16px',
                :habilitarAcaoRota='false'
            )
        .editar-atalho__body__opcoes.col-12
            .row.m-0
                .editar-atalho__body__opcoes.col-3.p-0(
                    v-for='opcao in Object.keys(atalhos)',
                    :key='opcao'
                )
                    section.editar-atalho__body__opcoes__titulo
                        | {{ internacionalizarTexto(opcao, 'grupo') }}
                    section.editar-atalho__body__opcoes__body.row
                        .col-12.p-0(
                            v-for='opcao in atalhos[opcao]',
                            :key='opcao.id'
                        )
                            el-switch.mt-4(
                                :width='30',
                                v-model='opcao.ativo',
                                :active-text="internacionalizarTexto(opcao.nome, 'botao')",
                                active-color='var(--secondary)',
                                inactive-color='var(--background-disabled)',
                                @change='filtrarAtalhosAtivos()'
                            )

    section.editar-atalho__footer.row
        .col-12.justify-content-end.p-0.mt-5.d-flex
            BaseButton.editar-atalho__footer_botao(@click='confirmar') {{ $t('mensagens.comuns.confirmar') }}
</template>

<script>
import Atalho from '@/components/home/acessoRapido/Atalho';
import AtalhoService from '@/services/AtalhoService';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'AcessoRapido',
    components: {
        Atalho,
        BaseButton
    },
    data() {
        return {
            atalhos: [],
            atalhosAtivos: [],
            mostrarDialog: true
        };
    },
    mounted() {
        this.buscarAtalhos();
    },
    methods: {
        internacionalizarTexto(texto, tipo) {
            let textoFormatado = texto
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace(/[^a-zA-Z0-9 ]/g, '')
                .replace(/\s+/g, '-')
                .toUpperCase();

            if (tipo === 'botao') {
                return this.$t(
                    `mensagens.home.acessoRapido.botoes.${textoFormatado}`
                );
            } else {
                return this.$t(
                    `mensagens.home.acessoRapido.grupos.${textoFormatado}`
                );
            }
        },

        buscarAtalhos() {
            AtalhoService.buscarAtalhosAgrupadosPorCategoria()
                .then(response => {
                    this.atalhos = response.data.atalhos;
                })
                .finally(() => this.filtrarAtalhosAtivos());
        },
        confirmar() {
            AtalhoService.atribuirAtalhos({
                id: this.atalhosAtivos.map(item => item.id)
            }).then(() => {
                this.$notify.success({
                    message: this.$t(
                        'mensagens.home.acessoRapido.atalhosEditadosComSucesso'
                    )
                });
            });
        },
        fecharAcessoRapido() {
            this.$router.push('/');
        },
        filtrarAtalhosAtivos() {
            const ativos = [];
            Object.keys(this.atalhos).forEach(atalho => {
                this.atalhos[atalho]
                    .filter(item => item.ativo)
                    .forEach(item => ativos.push(item));
            });

            this.atalhosAtivos = ativos;
        }
    }
};
</script>

<style scoped lang="scss">
.editar-atalho {
    height: 100vh;
    width: 100vw;
    padding: 50px 116px;
    margin: 0;
    background-color: #f2f2f2;
    position: absolute;
    z-index: 2000;
    top: 0;
    left: 0;

    .editar-atalho__header {
        margin: 0 0 49px;

        .editar-atalho__header__actionclose {
            font-size: 14px;
            font-weight: 500;
            justify-content: flex-end;
            display: flex;
            height: 46px;
            padding: 0;

            .editar-atalho__header__actionclose--enabled {
                display: flex;
                align-items: center;
                cursor: pointer;
            }
        }

        .editar-atalho__header__title {
            font-size: 30px;
            font-weight: 600;
            height: 36px;
            padding: 0;
            margin-bottom: 12px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .editar-atalho__header__subtitle {
            font-size: 16px;
            height: 20px;
            padding: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }

    .editar-atalho__body {
        height: auto;
        margin: 0;

        .editar-atalho__body__title {
            padding: 0;
            font-size: 16px;
            font-weight: 600;
            height: 19px;
            margin: 0 0 10px;
        }

        .editar-atalho__body__atalhos {
            height: 129px;
            padding: 0;
            display: flex;
            overflow-x: auto;
            border-bottom: 1.5px solid var(--background-disabled);
        }

        .editar-atalho__body__opcoes {
            padding: 0;
            height: 100%;

            .editar-atalho__body__opcoes__titulo {
                margin-top: 41px;
                font-size: 16px;
                font-weight: 600;
            }

            .editar-atalho__body__opcoes__body {
                margin: 0;
            }
        }
    }

    .editar-atalho__footer {
        margin: 0;

        .editar-atalho__footer_botao {
            font-weight: 400;
            font-size: 16px;
            background: var(--secondary-two);
            color: var(--white);
            border-radius: 5px;
        }
    }
}
</style>
